import React, { useState, useEffect } from 'react';
import { CallAPI } from 'actions/General';
import { useLocation } from 'react-router-dom';
import PieChartComponent from './charts/PieChartComponent';
import BarChartComponent from './charts/BarChartComponent';
import LineChartComponent from './charts/LineChartComponent';
import issuesGreyIcon from 'assets/images/icons/issues-grey.svg';
import { useTranslation } from 'react-i18next';

const AnalyticsPage = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const [analyticsDetail, setAnalyticsDetail] = useState(null);
  const getAnalyticsDetail = async () => {
    const result = await CallAPI(
      'GET_PAGE_ANALYTICS_DETAIL',
      { pageId: location?.state?.pageId ?? '695f5949a174e66173aee42e' },
      null,
      null,
      null,
    );
    if (result.status) {
      setAnalyticsDetail(result.data);
      console.log(result.data);
    }
  };
  useEffect(() => {
    getAnalyticsDetail();
  }, [location]);

  return (
    <div className='container-fluid p-4 bg-white rounded-2 d-flex flex-wrap gap-2'>
      {analyticsDetail &&
        analyticsDetail.map((singleWidget, index) =>
          singleWidget.chartType === 'pieChart' ||
          singleWidget.chartType === 'doughnutChart' ||
          singleWidget.chartType === 'dialChart' ? (
            <PieChartComponent
              data={singleWidget.data}
              title={singleWidget.caption}
              key={index}
              chartType={singleWidget.chartType}
            />
          ) : singleWidget.chartType === 'barChartHorizontal' ||
            singleWidget.chartType === 'barChartVertical' ? (
            <BarChartComponent
              data={singleWidget.data}
              key={index}
              title={singleWidget.caption}
              isVertical={singleWidget.chartType === 'barChartVertical'}
            />
          ) : singleWidget.chartType === 'lineChart' ? (
            <LineChartComponent
              data={singleWidget.data}
              key={index}
              title={singleWidget.caption}
              isVertical={singleWidget.chartType === 'barChartVertical'}
            />
          ) : (
            <>
              <div className='d-flex flex-column justify-content-center align-items-center flex-grow-1 px-3'>
                <div className='small text-center theme-text-grey-1 mb-2'>
                  {t('text_no_of_submissions')}
                </div>
                <div className='display-6 fw-bold text-center theme-text-black-1 mb-3'>
                  {singleWidget.data.count}
                </div>
                <div className='d-flex justify-content-center align-items-center mt-2'>
                  <img src={issuesGreyIcon} alt='info' className='issues-grey' />
                </div>
              </div>
            </>
          ),
        )}
    </div>
  );
};

export default AnalyticsPage;
